import { useCallback, useState } from 'react'
import { useStateManager } from 'react-query-state-manager'

import { useSaveAffiliatedCompany } from 'commons/hooks/bank/affiliatedCompany'
import { Keys } from 'state-manager'
import { Toast } from 'ui/components/Toast'

import { handlerServerError } from '@orbit/errors'

import { MappedAffiliatedCompany } from '../MappedAffiliatedCompany'

export const useAffiliatedCompanyManage = (companyId: number, companyName: string, refreshWebpage: () => void) => {
  const [relation, setRelation] = useState<MappedAffiliatedCompany | undefined>(undefined)
  const sm = useStateManager()

  const { routine: saveAffiliatedCompany, isLoading } = useSaveAffiliatedCompany({
    onSuccess: async (_, response) => {
      refreshWebpage()
      Toast.successSmall(`Affiliation successfully saved.`)
      setRelation(undefined)

      if (response.parentCompanyId) {
        sm.invalidate(Keys.CompanyDetails.WebPage(response.parentCompanyId))
      }
    },
    onError: (error) => handlerServerError(error)
  })

  const openAddDialog = useCallback(() => {
    setRelation({
      id: 0,
      mainCompanyId: companyId,
      mainCompanyName: companyName,
      affiliatedCompanyId: 0,
      affiliatedCompanyName: '',
      notes: ''
    })
  }, [setRelation, companyId, companyName])

  const openEditDialog = useCallback(
    (item: MappedAffiliatedCompany) => {
      setRelation(item)
    },
    [setRelation]
  )

  const closeManageDialog = useCallback(() => {
    setRelation(undefined)
  }, [setRelation])

  const onSubmit = useCallback(
    ({ id, notes, affiliatedCompanyId }: MappedAffiliatedCompany) => {
      if (id) {
        return saveAffiliatedCompany({
          id,
          notes
        })
      } else {
        return saveAffiliatedCompany({
          notes,
          parentCompanyId: companyId,
          childCompanyId: affiliatedCompanyId
        })
      }
    },
    [saveAffiliatedCompany, companyId]
  )
  return {
    openAddDialog,
    openEditDialog,
    relation,
    onSubmit,
    closeManageDialog,
    isLoading
  }
}
